import { Link } from 'react-router-dom';
import { useNextTask, useResolverUrl } from '../utils/hooks';
import { Button } from '../../../components';

interface NextButtonProps {
  children?: React.ReactNode;
}

export const NextButton = ({ children }: NextButtonProps) => {
  const nextTask = useNextTask();
  const resolverUrl = useResolverUrl();

  return (
    <Button
      as={Link}
      to={`${resolverUrl}/${nextTask ? `task/${nextTask.id}` : 'complete'}`}
      size="xlarge"
    >
      {children || 'Continue'}
    </Button>
  );
};
